import styled from '@emotion/styled';

import { su } from '../../theme/functions/su';

import { ZoneListItem } from './ZoneListItem';

const Item = styled.div`
  height: ${su(5)};
  padding: ${su(1)} 0 ${su(1)} ${(props) => su(props.level * 2)};
`;

const zoneList = (
  <div style={{ padding: `0 ${su(1)}` }}>
    <Item level={0}>
      <ZoneListItem />
    </Item>
    <Item level={1}>
      <ZoneListItem />
    </Item>
    <Item level={2}>
      <ZoneListItem />
    </Item>
    <Item level={2}>
      <ZoneListItem />
    </Item>
    <Item level={1}>
      <ZoneListItem />
    </Item>
    <Item level={2}>
      <ZoneListItem />
    </Item>
  </div>
);

export function ZoneList() {
  return zoneList;
}
